'use client';
import { jsx } from 'react/jsx-runtime';
import { BannerWithLeftHandNavigationBelowBannerContents } from './banner-with-left-hand-navigation-below-banner-contents.component.js';
import { BoundedContent } from '../bounded-content/bounded-content.component.js';
import { renderWithRef } from '../core/render-with-ref.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, n = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), n.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t.push.apply(t, n);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
const BannerWithLeftHandNavigationBelowBanner = renderWithRef('BannerWithLeftHandNavigationBelowBanner', null, (t, o)=>jsx(BoundedContent, _object_spread_props(_object_spread({
        ref: o
    }, t), {
        children: jsx(BannerWithLeftHandNavigationBelowBannerContents, {
            children: t.children
        })
    })));

export { BannerWithLeftHandNavigationBelowBanner };
